<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-products fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            ><h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              {{ title }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

        <v-container fluid>
          <v-form
            ref="form"
            v-model="isValid"
            lazy-validation
            @submit.prevent="submitForm"
          >
            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Mesa QR :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  v-model="input.table"
                  :rules="validationRules.table"
                  required
                  placeholder="E.g. c1"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Está Activo? :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-radio-group v-model="input.active" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Zona :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-select
                  v-model="input.zone_id"
                  :items="zoneTablesQR"
                  :rules="validationRules.zone"
                  item-text="name"
                  item-value="id"
                  label="Selecciona una zona"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-btn
                    dense
                    outlined
                    :disabled="!isValid"
                    :style="adminNavigationBackTheme"
                    type="submit"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Loader from "../../common/Loader";
import { qrCollection, saveQR, updateQR } from "@/collections/qrs";
import { qrZoneCollection } from "@/collections/qrZone";

export default {
  name: "table-qr-dialog",
  components: { Loader },
  data: () => ({
    itemId: "addTable",
    dialog: false,
    title: "",
    isValid: false,
    validationRules: {
      table: [v => (!!v && !!v.trim()) || "Mesa QR es requerido"],
      zone: [v => !!v || "Por favor, selecciona una zona"]
    },
    qrCollection: [],
    zoneTablesQR: [],
    input: {
      table: "",
      active: false,
      zone_id: ""
    },
    dialogLoader: true
  }),
  firestore() {
    return {
      qrCollection: qrCollection,
      zoneTablesQR: qrZoneCollection
    };
  },
  methods: {
    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage("Revisa el formulario");
        return;
      }

      try {
        if (this.itemId === "addTable") {
          // Create New

          let found = this.qrCollection.some(
            x =>
              x.table.toLowerCase().trim() ===
              this.input.table.toLowerCase().trim()
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }

          await saveQR(this.buildQR());
        } else {
          // check update unique name
          let found = this.qrCollection.some(
            x =>
              x.table.toLowerCase().trim() ===
                this.input.table.toLowerCase().trim() && x.id !== this.itemId
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }
          // Update Existing
          await updateQR(this.itemId, this.buildQR());
        }
        this.showSuccessMessage("Mesa QR guardado");

        this.close();
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "save/update_qr",
          "Obtained error message in submitForm()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
        return;
      }
    },
    buildQR() {
      let now = moment().format();
      return { ...this.input, updated_on: now };
    },
    open(itemId) {
      this.dialog = true;
      this.itemId = itemId;

      if (this.itemId === "addTable") {
        setTimeout(() => {
          this.title = "Crear Mesa QR";
        }, 100);
        this.dialogLoader = false;
        return;
      } else {
        setTimeout(() => {
          this.title = "Editar Mesa QR";
        }, 100);
      }

      setTimeout(() => {
        let qr = this.qrCollection.find(x => x.id === this.itemId);
        if (qr) {
          this.input = qr;
        }
        this.dialogLoader = false;
      }, 500);
    },
    close() {
      this.dialog = false;
      this.input = {
        table: "",
        active: false,
        zone_id: ""
      };
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style scoped lang="scss"></style>
